import { gql } from '@apollo/client';
import { mutate } from '../../../../../../common/graphql';
import { GET_MY_SUBMISSION_QUERY, Submission, SUBMISSION_FRAGMENT, SubmissionUnity56Encoding } from '../submission-graphql';
import { SubmissionAPSDetail } from '../../SubmitGame/submit-game-graphql';
import { GameLoaderType } from '@crazygames/game-types/src/game-build/loader.type';
import { UpdateStep } from '../../SubmitGame/submission-helpers';
import { MultiplayerOptions } from '../GameBaseForm/baseFormHelper';
import { FullscreenSetting } from '@crazygames/game-types/src/game-build/fullscreen.type';
import { GameOrientation } from '@crazygames/game-types/src/game-build/orientation.type';
import { GameCoverWithUploadedFileInput } from '@crazygames/graph-queries/submission/game-covers-uploaded-file-input.type';
import { UploadedFileInput } from '@crazygames/graph-queries/util/uploaded-file-input.type';
import { SubmissionVideo } from '@crazygames/graph-queries/submission/submission-video.type';

const UPDATE_SUBMISSION = gql`
  mutation updateSubmission($input: DeveloperSubmissionUpdateInput!) {
    developerSubmissionUpdate(input: $input) {
      ...SubmissionFragment
    }
  }
  ${SUBMISSION_FRAGMENT}
`;

export interface UpdateSubmissionMutation {
  developerSubmissionUpdate: Submission;
}

export interface DeveloperSubmissionUpdateInput {
  id: string;
  gameFiles: UploadedFileInput[];
  gameCovers?: GameCoverWithUploadedFileInput[];
  unity56Encoding?: SubmissionUnity56Encoding;

  gameName: string;
  categoryId?: string;
  tagIds?: string[];
  description?: string;
  controls?: string;

  iframeLink?: string;
  fullscreen: FullscreenSetting;
  isIOSFriendly: boolean;
  isAndroidFriendly: boolean;
  orientation: GameOrientation | null;
  steamStoreLink?: string;
  appStoreLink?: string;
  playStoreLink?: string;
  playStoreDownloads?: number;
  appStoreDownloads?: number;
  steamDownloads?: number;
  hasIAP: boolean;
  isChromebookFriendly: boolean;
  multiplayerOptions?: MultiplayerOptions;
  gameLoaderType: GameLoaderType;
  apsDetail: SubmissionAPSDetail;
  gameJamId?: string;
  updateStep: UpdateStep;
  videos: SubmissionVideo | null;
  allowEmbed: boolean;
}

export function updateSubmission(input: DeveloperSubmissionUpdateInput) {
  return mutate<DeveloperSubmissionUpdateInput, UpdateSubmissionMutation>(UPDATE_SUBMISSION, input, {
    refetchQueries: [
      // changes my result in new builds being created, so refetch submission so devs can see the latest builds when returning to the main screen
      { query: GET_MY_SUBMISSION_QUERY, variables: { id: input.id } },
    ],
    awaitRefetchQueries: true,
  });
}
